import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
export abstract class DialogBase {
    @Input() public isModalDisplayed = false;

    @Output()
    public acted = new EventEmitter();

    @Output()
    public visibleChange = new EventEmitter<boolean>();

    public openModal(): void {
        this.isModalDisplayed = true;
    }

    public closeModal(): void {
        this.isModalDisplayed = false;
        this.visibleChange.emit(false);
    }
}
